import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function OfferSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="offer" ref={ref} className="w-full bg-gradient-to-br from-rose/10 to-gold/10 py-10 md:py-16 px-6" data-id="element-78">
      <div className="max-w-4xl mx-auto" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-80">
          <h2 id="offer-heading" className="font-serif text-3xl md:text-4xl font-bold text-brown mb-4 scroll-mt-8" data-id="element-81">
            Tu Inversión en el Milagro
          </h2>

          <div className="bg-white rounded-3xl p-6 md:p-10 shadow-xl border-2 border-gold/30 mb-6" data-id="element-82">
            <p className="font-sans text-lg text-brown/90 leading-relaxed mb-6" data-id="element-83">
              Hoy puedes acceder al sistema completo "El Código del Vientre",
              incluyendo el eBook, las plantillas de trabajo y los audios de
              meditación sistémica.
            </p>

            <div id="offer-price" className="flex items-center justify-center gap-4 mb-6 scroll-mt-24" data-id="element-84">
              <div className="text-center" data-id="element-85">
                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-86">
                  <span className="font-serif text-4xl text-brown/40 line-through" data-id="element-87">
                    $27
                  </span>
                  <span className="font-serif text-6xl md:text-7xl font-bold text-rose" data-id="element-88">
                    $6.36
                  </span>
                </div>
                <div className="font-sans text-lg text-brown/60" data-id="element-89">
                  USD - Pago Único
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center gap-2 mb-6" data-id="element-90">
              <div className="flex items-center gap-2 text-brown/70" data-id="element-91">
                <CheckIcon className="w-5 h-5 text-rose" data-id="element-92" />
                <span className="font-sans text-base" data-id="element-93">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-2 text-brown/70" data-id="element-94">
                <CheckIcon className="w-5 h-5 text-rose" data-id="element-95" />
                <span className="font-sans text-base" data-id="element-96">
                  Todos los materiales incluidos
                </span>
              </div>
              <div className="flex items-center gap-2 text-brown/70" data-id="element-97">
                <CheckIcon className="w-5 h-5 text-rose" data-id="element-98" />
                <span className="font-sans text-base" data-id="element-99">Tuyo para siempre</span>
              </div>
            </div>

            <motion.button id="offer-cta" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} onClick={() => {
            trackAddToCart();
            window.open('https://www.inerciacero.com/cart/42837827551335:1', '_blank');
          }} className="bg-gradient-to-r from-rose to-gold text-white font-sans font-bold text-xl px-16 py-6 rounded-full shadow-2xl hover:shadow-xl transition-shadow w-full md:w-auto cursor-pointer" data-id="element-100">
              Quiero Sanar Mi Linaje y Recibir a Mi Hijo
            </motion.button>

            <p className="font-sans text-sm text-brown/60 mt-6" data-id="element-101">
              Acceso inmediato y discreto para comenzar esta misma noche.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}